import toast, { ToastOptions } from 'react-hot-toast'

interface IMessage {
  message: any
}

const toaster = {
  success: ({ message }: IMessage, options?: ToastOptions) =>
    toast.success(message, options),
  error: ({ message }: IMessage, options?: ToastOptions) =>
    toast.error(message, options),
}

export default toaster
